import { defineMeta } from '@/registry/types';

export const tabsMeta = defineMeta({
  name: 'Tabs',
  level: 'molecule',
  category: 'navigation',
  classification: 'themed-mui',
  description: 'Switch between related views within the same context. Themed MUI Tabs/Tab.',
  baseLibrary: '@mui/material',
  muiEquivalent: 'Tabs',
  muiDocs: 'https://mui.com/material-ui/react-tabs/',
  a2uiEquivalent: 'Tabs',
  importPath: '@/molecules/Tabs',
  requiredProps: ['value', 'onChange'],
  optionalProps: ['variant', 'orientation', 'scrollButtons'],
  supportedStates: ['default', 'selected', 'disabled', 'scrollable'],
  designTokens: ['colors', 'typography'],
  accessibility: [
    'Provide aria-label on Tabs; use tabpanel roles for content if needed.',
    'Keyboard: arrows move focus, Enter/Space selects.',
  ],
  usageExamples: [
    '<Tabs value={tab} onChange={(_, next) => setTab(next)} aria-label="asset detail tabs"><Tab label="Overview" /></Tabs>',
  ],
  rules: [
    'The strip ships its own type. Panel content you render underneath is `Typography variant="body1"` (or a layout that already applies a variant).',
  ],
  antiPatterns: ['Do not use tabs for sequential steps (use Stepper).'],
  llmSafe: true,
  whenToUse: ['Peer views within one screen'],
  whenNotToUse: ['Primary navigation (use LeftNavigation)', 'Wizards (use Stepper)'],
});

export default tabsMeta;
